import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContextService } from '@core/providers/context/context.service';
import { ContextObject } from '@shared/interfaces/login-object';

@Service()
export class QrUrlsGuard {
  private contextService = inject(ContextService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.contextService.getContext$().pipe(
      map((context: ContextObject) => {
        const canActivate: boolean = ContextService.isAccountContext(context);

        if (!canActivate) {
          void this.router.navigate(['/']);
        }

        return canActivate;
      })
    );
  }
}
